import { render, staticRenderFns } from "./i4pro-color-picker.vue?vue&type=template&id=12bfd1b0&scoped=true"
import script from "./i4pro-color-picker.vue?vue&type=script&lang=js"
export * from "./i4pro-color-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bfd1b0",
  null
  
)

export default component.exports